import { bootLegacyPublic } from '@/legacy/boot_public';

let bootPromise;

/**
 * Arranca vendor + app legacy public una sola vez.
 */
export function ensureLegacyPublic() {
  if (!bootPromise) {
    bootPromise = bootLegacyPublic();
  }
  return bootPromise;
}
